import React from "react";
import useStyles from "./ValidationErrors.css";
import translation from "../../i18n/i18.json";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  Grid,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { FormError } from "../../models/FormValidation/FormError";

interface ValidationErrorsMeta {
  errorList: Array<FormError>;
  open: boolean;
  setOpen: any;
}

export default function ValidationErrors(props: ValidationErrorsMeta) {
  const classes = useStyles();
  const { open, setOpen, errorList } = props;

  const handleClose = () => {
    setOpen(false);
  };

  const onCloseBtnClick = () => {
    setOpen(false);
  };

  return (
    <div>
      {" "}
      <Dialog
        className={classes.popUpOuter}
        open={open}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
      >
        <DialogTitle className={classes.popUpHeader}>
          {translation.validation_errors_title}
        </DialogTitle>
        <DialogContent className={classes.NoPopWrapper}>
          <div className={classes.tblOuterBG}>
            <TableContainer className={classes.tblContainer}>
              <Table>
                <TableBody className={classes.tblBody}>
                  {errorList.map((row) => (
                    <TableRow key={row.fieldName}>
                      <TableCell component="th" scope="row">
                        {row.errorMsg}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </DialogContent>
        <DialogActions>
          <div style={{ float: "left", margin: "20px 10px 0px 0" }}>
            <div className={classes.grayBtnWrapper}>
              <Button onClick={onCloseBtnClick} color="primary" autoFocus>
                {translation.popup_close_btn_txt}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
